export { default as MaterialsAppliedFilters } from './MaterialsAppliedFilters';
